import { render, staticRenderFns } from "./UserCourseDetail.vue?vue&type=template&id=4e16d3b8&"
import script from "./UserCourseDetail.vue?vue&type=script&lang=js&"
export * from "./UserCourseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports